import React, { useState } from 'react';

import { Modal } from '../ui';

import LoginForm from './LoginForm';
import PasswordResetForm from './PasswordResetForm';
import RegisterForm from './RegisterForm';

export type AuthModalMode = 'login' | 'register' | 'reset-password';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialMode?: AuthModalMode;
  onSuccess?: () => void;
}

const AuthModal: React.FC<AuthModalProps> = ({
  isOpen,
  onClose,
  initialMode = 'login',
  onSuccess,
}) => {
  const [currentMode, setCurrentMode] = useState<AuthModalMode>(initialMode);

  const handleSuccess = () => {
    onSuccess?.();
    onClose();
  };

  const handleModeChange = (mode: AuthModalMode) => {
    setCurrentMode(mode);
  };

  const renderForm = () => {
    switch (currentMode) {
      case 'login':
        return (
          <div>
            <LoginForm onSuccess={handleSuccess} onCancel={onClose} />
            <div className="mt-6 text-center space-y-2">
              <p className="text-sm text-white">
                アカウントをお持ちでない方は{' '}
                <button
                  onClick={() => handleModeChange('register')}
                  className="text-blue-300 hover:text-blue-200 font-medium"
                >
                  こちら
                </button>
              </p>
              <p className="text-sm text-white">
                パスワードを忘れた方は{' '}
                <button
                  onClick={() => handleModeChange('reset-password')}
                  className="text-blue-300 hover:text-blue-200 font-medium"
                >
                  こちら
                </button>
              </p>
            </div>
          </div>
        );

      case 'register':
        return (
          <div>
            <RegisterForm onSuccess={handleSuccess} onCancel={onClose} />
            <div className="mt-6 text-center">
              <p className="text-sm text-white">
                既にアカウントをお持ちの方は{' '}
                <button
                  onClick={() => handleModeChange('login')}
                  className="text-blue-300 hover:text-blue-200 font-medium"
                >
                  ログイン
                </button>
              </p>
            </div>
          </div>
        );

      case 'reset-password':
        return (
          <div>
            <PasswordResetForm onSuccess={handleSuccess} onCancel={onClose} />
            <div className="mt-6 text-center">
              <p className="text-sm text-white">
                <button
                  onClick={() => handleModeChange('login')}
                  className="text-blue-300 hover:text-blue-200 font-medium"
                >
                  ログインに戻る
                </button>
              </p>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-md" title="認証" screenName="auth">
      <div className="p-6">{renderForm()}</div>
    </Modal>
  );
};

export default AuthModal;
